import React from "react";
import { Dialog } from "../../Dialog";
const NoEOSModal = (props) => {
    return (React.createElement(Dialog, { show: true, title: "Message", body: () => React.createElement("p", null, "No EOS data available. Please try again later."), CloseIcon: true, buttons: [
            {
                label: "Close",
                size: "large",
                variant: "text",
                type: "button",
                className: "Close",
                onClick: () => props.SetViewDownloadModal(""),
            },
        ], handleCallback: (data) => {
            props.SetViewDownloadModal("");
        } }));
};
export default React.memo(NoEOSModal);
